export enum Language {
  UA = 'ua',
  EN = 'en',
  RU = 'ru',
  UK = 'uk'
}

export enum Locale {
  UA = 'uk-UA',
  EN = 'en-GB'
}
